import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "className", "href", "target", "active", "disabled", "onClick", "data-test"];
import React from 'react';
import PropTypes from 'prop-types';
import StyledPill from './Pills.styles';

var Pill = function Pill(_ref) {
  var label = _ref.label,
      className = _ref.className,
      href = _ref.href,
      target = _ref.target,
      active = _ref.active,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      dataTest = _ref['data-test'],
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledPill, _extends({
    as: href ? 'a' : 'button',
    className: className,
    href: !disabled ? href : undefined,
    target: target,
    active: active,
    disabled: disabled,
    onClick: onClick,
    tabIndex: !disabled ? 0 : undefined,
    "data-test": "".concat(dataTest).concat(active ? '--active' : '')
  }, props), label);
};

Pill.displayName = 'Pill';
Pill.propTypes = {
  /**
   * Required content of the Pill
   */
  label: PropTypes.node.isRequired,

  /**
   * Optional flag indicating if the pill is in the active state
   */
  active: PropTypes.bool,

  /**
   * Optional flag indicating if the pill is in the disabled state
   */
  disabled: PropTypes.bool,

  /**
   * Optional link for the Pill
   */
  href: PropTypes.string,

  /**
   * Optional definition of where to open the linked document
   */
  target: PropTypes.string,

  /**
   * Optional function to be called when Pill is clicked
   */
  onClick: PropTypes.func,

  /**
   * Specify an optional data-test attribute to be added to your Pill component for e2e testing
   */
  'data-test': PropTypes.string
};
Pill.defaultProps = {
  target: '_self',
  active: false,
  disabled: false,
  onClick:
  /* istanbul ignore next */
  function onClick() {},
  'data-test': 'component-pill'
};
export default Pill;